import SelectAndInput from "../../design/SelectAndInput";


export default ({value, setValue}) => {

    const currency_data = {
        "ADA": {name: "Cardano", symbol: "₳"},
        "AED": {name: "Emirati Dirham", symbol: "د.إ"},
        "AFN": {name: "Afghan Afghani", symbol: "؋"},
        "ALL": {name: "Albanian Lek", symbol: "L"},
        "AMD": {name: "Armenian Dram", symbol: "֏"},
        "ANG": {name: "Dutch Guilder", symbol: "ƒ"},
        "AOA": {name: "Angolan Kwanza", symbol: "Kz"},
        "ARS": {name: "Argentine Peso", symbol: "$"},
        "ATS": {name: "Austrian Schilling", symbol: "öS"},
        "AUD": {name: "Australian Dollar", symbol: "$"},
        "AWG": {name: "Aruban or Dutch Guilder", symbol: "ƒ"},
        "AZM": {name: "Azerbaijani Manat", symbol: "ман"},
        "AZN": {name: "Azerbaijan Manat", symbol: "₼"},
        "BAM": {name: "Bosnian Convertible Mark", symbol: "КМ"},
        "BBD": {name: "Barbadian or Bajan Dollar", symbol: "$"},
        "BCH": {name: "Bitcoin Cash", symbol: "BCH"},
        "BDT": {name: "Bangladeshi Taka", symbol: "৳"},
        "BEF": {name: "Belgian Franc", symbol: "₣"},
        "BGN": {name: "Bulgarian Lev", symbol: "лв"},
        "BHD": {name: "Bahraini Dinar", symbol: "ب.د"},
        "BIF": {name: "Burundian Franc", symbol: "₣"},
        "BMD": {name: "Bermudian Dollar", symbol: "$"},
        "BND": {name: "Bruneian Dollar", symbol: "$"},
        "BOB": {name: "Bolivian Bolíviano", symbol: "Bs."},
        "BRL": {name: "Brazilian Real", symbol: "R$"},
        "BSD": {name: "Bahamian Dollar", symbol: "$"},
        "BTC": {name: "Bitcoin", symbol: "₿"},
        "BTN": {name: "Bhutanese Ngultrum", symbol: "Nu."},
        "BWP": {name: "Botswana Pula", symbol: "P"},
        "BYN": {name: "Belarusian Ruble", symbol: "Br"},
        "BYR": {name: "Belarusian Ruble", symbol: "Br"},
        "BZD": {name: "Belizean Dollar", symbol: "BZ$"},
        "CAD": {name: "Canadian Dollar", symbol: "C$"},
        "CDF": {name: "Congolese Franc", symbol: "FC"},
        "CHF": {name: "Swiss Franc", symbol: "CHF"},
        "CLP": {name: "Chilean Peso", symbol: "$"},
        "CNH": {name: "Chinese Yuan Renminbi Offshore", symbol: "¥"},
        "CNY": {name: "Chinese Yuan Renminbi", symbol: "¥"},
        "COP": {name: "Colombian Peso", symbol: "$"},
        "CRC": {name: "Costa Rican Colon", symbol: "₡"},
        "CUC": {name: "Cuban Convertible Peso", symbol: "$"},
        "CUP": {name: "Cuban Peso", symbol: "$MN"},
        "CVE": {name: "Cape Verdean Escudo", symbol: "$"},
        "CYP": {name: "Cypriot Pound", symbol: "£"},
        "CZK": {name: "Czech Koruna", symbol: "Kč"},
        "DEM": {name: "German Deutsche Mark", symbol: "DM"},
        "DJF": {name: "Djiboutian Franc", symbol: "Fdj"},
        "DKK": {name: "Danish Krone", symbol: "kr"},
        "DOGE": {name: "Dogecoin", symbol: "Ð"},
        "DOP": {name: "Dominican Peso", symbol: "RD$"},
        "DOT": {name: "Polkadot", symbol: "DOT"},
        "DZD": {name: "Algerian Dinar", symbol: "د.ج"},
        "EEK": {name: "Estonian Kroon", symbol: "KR"},
        "EGP": {name: "Egyptian Pound", symbol: "E£"},
        "ERN": {name: "Eritrean Nakfa", symbol: "Nfk"},
        "ESP": {name: "Spanish Peseta", symbol: "₧"},
        "ETB": {name: "Ethiopian Birr", symbol: "Br"},
        "ETH": {name: "Ethereum", symbol: "Ξ"},
        "EUR": {name: "Euro", symbol: "€"},
        "FIM": {name: "Finnish Markka", symbol: "mk"},
        "FJD": {name: "Fijian Dollar", symbol: "$"},
        "FKP": {name: "Falkland Island Pound", symbol: "£"},
        "FRF": {name: "French Franc", symbol: "₣"},
        "GBP": {name: "British Pound", symbol: "£"},
        "GEL": {name: "Georgian Lari", symbol: "₾"},
        "GGP": {name: "Guernsey Pound", symbol: "£"},
        "GHC": {name: "Ghanaian Cedi", symbol: "₵"},
        "GHS": {name: "Ghanaian Cedi", symbol: "GH₵"},
        "GIP": {name: "Gibraltar Pound", symbol: "£"},
        "GMD": {name: "Gambian Dalasi", symbol: "D"},
        "GNF": {name: "Guinean Franc", symbol: "FG"},
        "GRD": {name: "Greek Drachma", symbol: "₯"},
        "GTQ": {name: "Guatemalan Quetzal", symbol: "Q"},
        "GYD": {name: "Guyanese Dollar", symbol: "GY$"},
        "HKD": {name: "Hong Kong Dollar", symbol: "HK$"},
        "HNL": {name: "Honduran Lempira", symbol: "L"},
        "HRK": {name: "Croatian Kuna", symbol: "kn"},
        "HTG": {name: "Haitian Gourde", symbol: "G"},
        "HUF": {name: "Hungarian Forint", symbol: "Ft"},
        "IDR": {name: "Indonesian Rupiah", symbol: "Rp"},
        "IEP": {name: "Irish Pound", symbol: "£"},
        "ILS": {name: "Israeli Shekel", symbol: "₪"},
        "IMP": {name: "Isle of Man Pound", symbol: "£"},
        "INR": {name: "Indian Rupee", symbol: "₹"},
        "IQD": {name: "Iraqi Dinar", symbol: "ع.د"},
        "IRR": {name: "Iranian Rial", symbol: "﷼"},
        "ISK": {name: "Icelandic Krona", symbol: "kr"},
        "ITL": {name: "Italian Lira", symbol: "₤"},
        "JEP": {name: "Jersey Pound", symbol: "£"},
        "JMD": {name: "Jamaican Dollar", symbol: "J$"},
        "JOD": {name: "Jordanian Dinar", symbol: "د.ا"},
        "JPY": {name: "Japanese Yen", symbol: "¥"},
        "KES": {name: "Kenyan Shilling", symbol: "KSh"},
        "KGS": {name: "Kyrgyzstani Som", symbol: "с"},
        "KHR": {name: "Cambodian Riel", symbol: "៛"},
        "KMF": {name: "Comorian Franc", symbol: "CF"},
        "KPW": {name: "North Korean Won", symbol: "₩"},
        "KRW": {name: "South Korean Won", symbol: "₩"},
        "KWD": {name: "Kuwaiti Dinar", symbol: "د.ك"},
        "KYD": {name: "Caymanian Dollar", symbol: "$"},
        "KZT": {name: "Kazakhstani Tenge", symbol: "₸"},
        "LAK": {name: "Lao Kip", symbol: "₭"},
        "LBP": {name: "Lebanese Pound", symbol: "ل.ل"},
        "LINK": {name: "Chainlink", symbol: "LINK"},
        "LKR": {name: "Sri Lankan Rupee", symbol: "රු"},
        "LRD": {name: "Liberian Dollar", symbol: "$"},
        "LSL": {name: "Basotho Loti", symbol: "L"},
        "LTC": {name: "Litecoin", symbol: "Ł"},
        "LTL": {name: "Lithuanian Litas", symbol: "Lt"},
        "LUF": {name: "Luxembourg Franc", symbol: "₣"},
        "LUNA": {name: "Terra", symbol: "LUNA"},
        "LVL": {name: "Latvian Lat", symbol: "Ls"},
        "LYD": {name: "Libyan Dinar", symbol: "ل.د"},
        "MAD": {name: "Moroccan Dirham", symbol: "د.م."},
        "MDL": {name: "Moldovan Leu", symbol: "L"},
        "MGA": {name: "Malagasy Ariary", symbol: "Ar"},
        "MGF": {name: "Malagasy Franc", symbol: "₣"},
        "MKD": {name: "Macedonian Denar", symbol: "ден"},
        "MMK": {name: "Burmese Kyat", symbol: "K"},
        "MNT": {name: "Mongolian Tughrik", symbol: "₮"},
        "MOP": {name: "Macau Pataca", symbol: "MOP$"},
        "MRO": {name: "Mauritanian Ouguiya", symbol: "UM"},
        "MRU": {name: "Mauritanian Ouguiya", symbol: "UM"},
        "MTL": {name: "Maltese Lira", symbol: "₤"},
        "MUR": {name: "Mauritian Rupee", symbol: "₨"},
        "MVR": {name: "Maldivian Rufiyaa", symbol: "Rf"},
        "MWK": {name: "Malawian Kwacha", symbol: "MK"},
        "MXN": {name: "Mexican Peso", symbol: "$"},
        "MYR": {name: "Malaysian Ringgit", symbol: "RM"},
        "MZM": {name: "Mozambican Metical", symbol: "MTn"},
        "MZN": {name: "Mozambican Metical", symbol: "MT"},
        "NAD": {name: "Namibian Dollar", symbol: "$"},
        "NGN": {name: "Nigerian Naira", symbol: "₦"},
        "NIO": {name: "Nicaraguan Cordoba", symbol: "C$"},
        "NLG": {name: "Dutch Guilder", symbol: "ƒ"},
        "NOK": {name: "Norwegian Krone", symbol: "kr"},
        "NPR": {name: "Nepalese Rupee", symbol: "₨"},
        "NZD": {name: "New Zealand Dollar", symbol: "$"},
        "OMR": {name: "Omani Rial", symbol: "ر.ع."},
        "PAB": {name: "Panamanian Balboa", symbol: "B/."},
        "PEN": {name: "Peruvian Sol", symbol: "S/."},
        "PGK": {name: "Papua New Guinean Kina", symbol: "K"},
        "PHP": {name: "Philippine Peso", symbol: "₱"},
        "PKR": {name: "Pakistani Rupee", symbol: "₨"},
        "PLN": {name: "Polish Zloty", symbol: "zł"},
        "PTE": {name: "Portuguese Escudo", symbol: "Esc"},
        "PYG": {name: "Paraguayan Guarani", symbol: "₲"},
        "QAR": {name: "Qatari Riyal", symbol: "ر.ق"},
        "ROL": {name: "Romanian Leu", symbol: "L"},
        "RON": {name: "Romanian Leu", symbol: "L"},
        "RSD": {name: "Serbian Dinar", symbol: "дин."},
        "RUB": {name: "Russian Ruble", symbol: "₽"},
        "RWF": {name: "Rwandan Franc", symbol: "RF"},
        "SAR": {name: "Saudi Arabian Riyal", symbol: "ر.س"},
        "SBD": {name: "Solomon Islander Dollar", symbol: "$"},
        "SCR": {name: "Seychellois Rupee", symbol: "₨"},
        "SDD": {name: "Sudanese Dinar", symbol: "LSd"},
        "SDG": {name: "Sudanese Pound", symbol: "SDG"},
        "SEK": {name: "Swedish Krona", symbol: "kr"},
        "SGD": {name: "Singapore Dollar", symbol: "$"},
        "SHP": {name: "Saint Helenian Pound", symbol: "£"},
        "SIT": {name: "Slovenian Tolar", symbol: "T"},
        "SKK": {name: "Slovak Koruna", symbol: "Sk"},
        "SLE": {name: "Sierra Leonean Leone", symbol: "Le"},
        "SLL": {name: "Sierra Leonean Leone", symbol: "Le"},
        "SOS": {name: "Somali Shilling", symbol: "Sh"},
        "SPL": {name: "Seborgan Luigino", symbol: "₰"},
        "SRD": {name: "Surinamese Dollar", symbol: "$"},
        "SRG": {name: "Surinamese Guilder", symbol: "ƒ"},
        "STD": {name: "Sao Tomean Dobra", symbol: "Db"},
        "STN": {name: "Sao Tomean Dobra", symbol: "Db"},
        "SVC": {name: "Salvadoran Colon", symbol: "$"},
        "SYP": {name: "Syrian Pound", symbol: "£S"},
        "SZL": {name: "Swazi Lilangeni", symbol: "E"},
        "THB": {name: "Thai Baht", symbol: "฿"},
        "TJS": {name: "Tajikistani Somoni", symbol: "ЅМ"},
        "TMM": {name: "Turkmenistani Manat", symbol: "m"},
        "TMT": {name: "Turkmenistani Manat", symbol: "T"},
        "TND": {name: "Tunisian Dinar", symbol: "د.ت"},
        "TOP": {name: "Tongan Pa'anga", symbol: "T$"},
        "TRL": {name: "Turkish Lira", symbol: "₤"},
        "TRY": {name: "Turkish Lira", symbol: "₺"},
        "TTD": {name: "Trinidadian Dollar", symbol: "TT$"},
        "TVD": {name: "Tuvaluan Dollar", symbol: "$"},
        "TWD": {name: "Taiwan New Dollar", symbol: "NT$"},
        "TZS": {name: "Tanzanian Shilling", symbol: "TSh"},
        "UAH": {name: "Ukrainian Hryvnia", symbol: "₴"},
        "UGX": {name: "Ugandan Shilling", symbol: "USh"},
        "UNI": {name: "Uniswap", symbol: "UNI"},
        "USD": {name: "US Dollar", symbol: "$"},
        "UYU": {name: "Uruguayan Peso", symbol: "$U"},
        "UZS": {name: "Uzbekistani Som", symbol: "so'm"},
        "VAL": {name: "Vatican City Lira", symbol: "₤"},
        "VEB": {name: "Venezuelan Bolívar", symbol: "Bs."},
        "VEF": {name: "Venezuelan Bolívar", symbol: "Bs."},
        "VES": {name: "Venezuelan Bolívar", symbol: "Bs."},
        "VND": {name: "Vietnamese Dong", symbol: "₫"},
        "VUV": {name: "Ni-Vanuatu Vatu", symbol: "VT"},
        "WST": {name: "Samoan Tala", symbol: "WS$"},
        "XAF": {name: "Central African CFA Franc BEAC", symbol: "FCFA"},
        "XAG": {name: "Silver Ounce", symbol: "XAG"},
        "XAU": {name: "Gold Ounce", symbol: "XAU"},
        "XCD": {name: "East Caribbean Dollar", symbol: "$"},
        "XDR": {name: "IMF Special Drawing Rights", symbol: "XDR"},
        "XEU": {name: "European Currency Unit", symbol: "XEU"},
        "XLM": {name: "Stellar Lumen", symbol: "XLM"},
        "XOF": {name: "CFA Franc", symbol: "CFA"},
        "XPD": {name: "Palladium Ounce", symbol: "XPD"},
        "XPF": {name: "CFP Franc", symbol: "XPF"},
        "XPT": {name: "Platinum Ounce", symbol: "XPT"},
        "XRP": {name: "Ripple", symbol: "XRP"},
        "YER": {name: "Yemeni Rial", symbol: "﷼"},
        "ZAR": {name: "South African Rand", symbol: "R"},
        "ZMK": {name: "Zambian Kwacha", symbol: "ZK"},
        "ZMW": {name: "Zambian Kwacha", symbol: "ZK"},
        "ZWD": {name: "Zimbabwean Dollar", symbol: "Z$"},
        "ZWL": {name: "Zimbabwean Dollar", symbol: "Z$"},
    };

    const list_currency_data = Object.keys(currency_data).map((value) => `${value} - ${currency_data[value]['name']}`)

    const selectCountry = (value) => {
        const subValue = value.substring(0, 3).toUpperCase();
        
        if (subValue.length > 2 && subValue in currency_data) {
            setValue(value, currency_data[subValue]['symbol']);
        } else {
            setValue(value);
        }
    }

    return (
        <SelectAndInput
        dataSelect={list_currency_data}
        filter={value}
        setFilter={selectCountry}
        />
    )
}